const Pages = new Map([

]);

export default Pages